import { render, staticRenderFns } from "./BrandsCarousel.vue?vue&type=template&id=85877410&scoped=true&"
import script from "./BrandsCarousel.vue?vue&type=script&lang=js&"
export * from "./BrandsCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85877410",
  null
  
)

export default component.exports